import React, { Component } from 'react';
import axios from "axios";
import Cookies from 'js-cookie';

import { IoMdLogIn } from 'react-icons/io';
import { IoMdQrScanner } from 'react-icons/io';
import { IoMdContacts } from 'react-icons/io';
import { IoMdCloudUpload } from "react-icons/io";

class Admin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            eventId: '',
            companyId: '',
            initials: '',
            message: '',
            signedIn: true,
            eventSync: 0,
            eventActive: 1,
            exportEmail: false,
            exportWorkEmail: false,
            exportJobTitle: false,
            exportCorporation: false,
            exportPhone: false,
            exportZipCode: false,
            exportDecisionmaker: false,
            enableImageUpload: false,
            deleteLeadsDate: '',
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
    }

    componentDidMount() {
        document.getElementById("app-window").focus();

        this.setState({ eventId: this.props.eventId });
        this.setState({ companyId: this.props.companyId });
        this.setState({ initials: this.props.initials });

        if (this.props.event && this.props.event.hasOwnProperty('event_sync')) {
            this.setState({ eventSync: this.props.event.event_sync });
            this.setState({ eventActive: this.props.event.event_active });
            this.setState({ exportEmail: parseFloat(this.props.event.export_email) === 1 ? true : false });
            this.setState({ exportWorkEmail: parseFloat(this.props.event.export_work_email) === 1 ? true : false });
            this.setState({ exportJobTitle: parseFloat(this.props.event.export_job_title) === 1 ? true : false });
            this.setState({ exportCorporation: parseFloat(this.props.event.export_corporation) === 1 ? true : false });
            this.setState({ exportPhone: parseFloat(this.props.event.export_phone) === 1 ? true : false });
            this.setState({ exportZipCode: parseFloat(this.props.event.export_zip_code) === 1 ? true : false });
            this.setState({ exportDecisionmaker: parseFloat(this.props.event.export_decisionmaker) === 1 ? true : false });
            this.setState({ enableImageUpload: parseFloat(this.props.event.enable_image_upload) === 1 ? true : false });
            this.setState({ deleteLeadsDate: this.props.event.delete_leads_date === null ? '' : this.props.event.delete_leads_date });

            setTimeout(() => {
                this.setState({ eventSync: this.props.event.event_sync });
                this.setState({ eventActive: this.props.event.event_active });
                this.setState({ exportEmail: parseFloat(this.props.event.export_email) === 1 ? true : false });
                this.setState({ exportWorkEmail: parseFloat(this.props.event.export_work_email) === 1 ? true : false });
                this.setState({ exportJobTitle: parseFloat(this.props.event.export_job_title) === 1 ? true : false });
                this.setState({ exportCorporation: parseFloat(this.props.event.export_corporation) === 1 ? true : false });
                this.setState({ exportPhone: parseFloat(this.props.event.export_phone) === 1 ? true : false });
                this.setState({ exportZipCode: parseFloat(this.props.event.export_zip_code) === 1 ? true : false });
                this.setState({ exportDecisionmaker: parseFloat(this.props.event.export_decisionmaker) === 1 ? true : false });
                this.setState({ enableImageUpload: parseFloat(this.props.event.enable_image_upload) === 1 ? true : false });
                this.setState({ deleteLeadsDate: this.props.event.delete_leads_date === null ? '' : this.props.event.delete_leads_date });
            }, 2000);
        } else {
            this.setState({ message: 'Event not found in App' });
        }
    }

    handleInputChange(e) {
        const itemName = e.target.name;
        const itemValue = e.target.value;
        this.setState({ [itemName]: itemValue });
    }

    handleCheckboxChange(e) {
        const itemName = e.target.id;
        const isChecked = e.target.checked;
        this.setState({ [itemName]: isChecked });
    }

    handleDateChange(e) {
        this.setState({ deleteLeadsDate: e.target.value });
    }

    updateEvent() {
        var myDiv = document.getElementById('app-window');
        myDiv.scrollTop = 0;

        this.setState({ message: 'Importing event' });

        var data = {};

        data.eventId = this.state.eventId;
        data.companyId = this.props.companyId;
        data.eventSync = this.state.eventSync;
        data.eventActive = this.state.eventActive;
        data.exportEmail = this.state.exportEmail;
        data.exportWorkEmail = this.state.exportWorkEmail;
        data.exportJobTitle = this.state.exportJobTitle;
        data.exportCorporation = this.state.exportCorporation;
        data.exportPhone = this.state.exportPhone;
        data.exportZipCode = this.state.exportZipCode;
        data.exportDecisionmaker = this.state.exportDecisionmaker;
        data.enableImageUpload = this.state.enableImageUpload;
        data.deleteLeadsDate = this.state.deleteLeadsDate;
        data.token = this.props.token;

        console.log(data);

        axios({
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            url: this.props.domain + '/core/connect.php?action=updateEvent',
            data: JSON.stringify(data)

        }).then((responseObject) => {
            console.log(responseObject);
            console.log(responseObject.data);

            if (responseObject.data.valid_token === true) {
                this.setState({ message: responseObject.data.message });

                this.props.connectionError(false);
                this.props.setAdmin(this.state.eventId, responseObject.data);
            } else {
                var prop = {};
                prop.appMessage = responseObject.data.result;
                this.props.changeScreen('setup', prop);
            }

        }).catch((error) => {
            console.log('in2');

            this.setState({ message: error });
            this.props.connectionError(true);
            console.log(error);
        });
    }

    startScan() {
        this.props.changeScreen('home', '');
    }

    signOut() {
        this.setState({ message: 'Signing Out' });
        this.setState({ signedIn: false });

        var data = {};
        data.token = this.props.token;

        axios({
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            url: this.props.domain + '/core/connect.php?action=signOut',
            data: JSON.stringify(data)

        }).then((responseObject) => {
            Cookies.remove('authToken');
            this.props.connectionError(false);
            this.props.changeScreen('setup', 'clearEvent');

        }).catch((error) => {
            this.props.connectionError(true);
            console.log(error);
        });
    }

    changePassword() {
        this.props.changeScreen('changepassword', '');
    }

    render() {
        const { eventId, colors, event, logoTop, logoBottom } = this.props;
        const hasEvent = event && Object.keys(event).length !== 0;

        const frontStyle = {
            color: colors.color_1,
            textShadow: '0px 4px 3px #00000030',
            whiteSpace: "pre-wrap"
        };

        const btnStyle = {
            color: colors.color_1,
            backgroundColor: colors.color_2,
            width: '200px',
            cursor: 'pointer',
        };

        return (
            <form onSubmit={this.handleSubmit} className="form-post-lead">
                <div className="container-fluid d-flex align-items-center vh-100">
                    <div className="row d-flex justify-content-center vh-100 vw-100">
                        <div className="content-wrapper page-setup col-12 col col-sm-8 col-lg-6">
                            <div className="content">

                                {logoTop !== '' &&
                                    <div className="section-top-wrapper">
                                        <img id="logo" src={logoTop} alt="Logo" />
                                    </div>
                                }

                                <div className="mt-3 mb-3" style={frontStyle}><strong>Admin</strong></div>

                                {this.state.message !== "" &&
                                    <div id="message" className="mb-3" style={frontStyle} dangerouslySetInnerHTML={{ __html: this.state.message }}></div>
                                }

                                {hasEvent &&
                                    <div className="mb-2 text-center" style={frontStyle}>
                                        <div><strong>EVENT</strong></div>
                                        <div>{event.event_name}</div>
                                        <div>#{eventId}</div>
                                    </div>
                                }

                                {!hasEvent &&
                                    <div>
                                        <div className="mb-1" style={frontStyle}>Event Id</div>
                                        <div className="mb-2">
                                            <input
                                                className={"form-control pl-3"}
                                                type="text"
                                                id="eventId"
                                                name="eventId"
                                                placeholder="Event Id"
                                                defaultValue={eventId}
                                                onChange={this.handleInputChange}
                                            />
                                        </div>
                                    </div>
                                }

                                {this.state.signedIn &&
                                    <div className="text-center">

                                        {hasEvent &&
                                            <div className="text-right m-2">
                                                <button
                                                    className="btn-medium"
                                                    type="button"
                                                    style={btnStyle}
                                                    onClick={() => this.props.changeScreen('leads', '')}
                                                >
                                                    Leads <IoMdContacts />
                                                </button>
                                            </div>
                                        }

                                        {hasEvent &&
                                            <div className="text-right m-2">
                                                <button
                                                    className="btn-medium"
                                                    type="button"
                                                    style={btnStyle}
                                                    onClick={() => this.startScan()}
                                                >
                                                    Scan <IoMdQrScanner />
                                                </button>
                                            </div>
                                        }

                                        {this.state.enableImageUpload && hasEvent &&
                                            <div className="text-right m-2">
                                                <button
                                                    className="btn-medium"
                                                    type="button"
                                                    style={btnStyle}
                                                    onClick={() => this.props.changeScreen('upload', '')}
                                                >
                                                    Upload <IoMdCloudUpload />
                                                </button>
                                            </div>
                                        }

                                        <div className="text-right m-2">
                                            <button
                                                className="btn-medium"
                                                type="button"
                                                style={btnStyle}
                                                onClick={() => this.signOut()}
                                            >
                                                Sign Out <IoMdLogIn />
                                            </button>
                                        </div>
                                    </div>
                                }
                            </div>

                            {logoBottom !== '' &&
                                <div className="section-bottom-wrapper mt-5">
                                    <div className="text-center">
                                        <img id="logo-bottom" src={logoBottom} alt="Logo" />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default Admin;